export default __webpack_public_path__ + "static/media/new-logo.8c53e3d9.png";